import React, {Component} from 'react';
import FiveDays from '../presentational/FiveDays';
import data from '../../core/data';

class FiveDaysContainer extends Component {
  render() {
    return (
      <section className="five-days" id="steps">
        <div className="container">
          <div className="row">
            <FiveDays day="1" body={ data.index.fiveDays.oneBold }>
              <p>{ data.index.fiveDays.one }</p>
            </FiveDays>
            <FiveDays day="2" body={data.index.fiveDays.two} />
            <FiveDays day="3" body={data.index.fiveDays.three} />
            <FiveDays day="4" body={data.index.fiveDays.four} />
            <FiveDays day="5" body={data.index.fiveDays.five} />
          </div>
        </div>
    </section>
    )
  }
}

export default FiveDaysContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/FiveDaysContainer.jsx
 **/